import { ref } from 'vue'

const lotSearchQueryString = ref('')

export default lotSearchQueryString
